import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  isLoading: false,
  isGrouped: false,
  sessions: {},
};

function onLoadSessionsFuture(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSessionsFutureSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    isGrouped: false,
    sessions: payload,
  };
}

function onLoadGroupSessionsFuture(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadGroupSessionsFutureSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    isGrouped: true,
    sessions: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadSessionsFuture,
  [actions.LOAD_SUCCESS]: onLoadSessionsFutureSuccess,
  [actions.LOAD_GROUP_REQUEST]: onLoadGroupSessionsFuture,
  [actions.LOAD_GROUP_SUCCESS]: onLoadGroupSessionsFutureSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
